<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="info && info.name ? info.name : ''"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      class="staff-from"
      v-loading="loading"
      inline
      element-loading-text="加载中…"
      ref="elFormDom"
      label-position="left"
      :model="form.data"
      :rules="form.rules"
      :size="subUnitSize"
    >
      <el-form-item label="客户名称" prop="merchant_id">
        <el-select
          v-model="form.data.merchant_id"
          filterable
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in merchantArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="">
        <el-button
          type="primary"
          @click="confirm"
          :loading="form.loading"
          :disabled="form.loading"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData" max-height="400" style="width: 100%">
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="name" label="客户名称"> </el-table-column>
      <el-table-column prop="action" label="操作" width="50">
        <template slot-scope="{ row }">
          <el-popconfirm title="确定删除该客户吗？" @confirm="del(row)">
            <el-button type="text" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          merchant_id: "",
        },
        rules: {
          merchant_id: [
            { required: true, message: "请选择", trigger: "change" },
          ],
        },
      },
      merchantArr: [], // 客户
      tableData: [],
    };
  },
  methods: {
    getDetail(row) {
      this.info = row;
      this.tableData = row.merchant;
      this.getMerchant(); // 客户
    },
    reset(done) {
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getMerchant() {
      // type 1:列表 2:参数
      this.$http
        .get("/admin/group/merchantList", {
          params: { type: 1, page: 1, count: 10000 },
        })
        .then((res) => {
          if (res.code == 1) {
            this.merchantArr = res.data.list;
          }
        });
    },
    del(row) {
      let params = {
        id: this.info.id,
        merchant_id: row.id,
      };
      this.$http.post("/admin/source/delete", params).then((res) => {
        if (res.code == 1) {
          this.$message.success("删除成功");
          this.tableData = this.tableData.filter((item) => item.id !== row.id);
          this.$emit("refresh");
        }
      });
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            merchant_id: this.form.data.merchant_id,
            id: this.info.id,
          };
          this.$http
            .post("/admin/source/add", params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("添加成功");
                this.$emit("refresh");
                let name = this.merchantArr.find(
                  (item) => item.id === params.merchant_id
                ).name;
                let list = [{ id: this.form.data.merchant_id, name: name }];
                this.tableData = [...list,...this.tableData,];
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
